/**
 * Helper class for requesting the capabilites of OWS services.
 */
import TileWmsSource from 'ol/source/TileWMS';

export const OwsCapsHelper = {

  /**
   * Requests the Capabilites of a WMS.
   *
   * @param {ol.source.TileWMS} tileWmsSource The OpenLayers source of the WMS
   * @param {String} [wmsVersion=1.3.0] The version of the WMS
   * @returns {Promise} A promise returning the capabilities text on success
   */
  requestWmsCapabilites: function (tileWmsSource, wmsVersion) {
    // ensure source is a WMS source
    if (!(tileWmsSource instanceof TileWmsSource)) {
      return;
    }

    if (!wmsVersion) {
      wmsVersion = '1.3.0';
    }

    const urls = tileWmsSource.getUrls();
    const baseUrl = urls[0];
    if (!baseUrl) {
      return;
    }
    const url = baseUrl +
        '?SERVICE=WMS' +
        `&VERSION=${wmsVersion}` +
        '&REQUEST=GetCapabilities';

    const wmsPromise = fetch(url).then(response => {
      return response.text();
    }).catch(error => {
      return error;
    });
    return wmsPromise;
  },

  /**
   * Extract the time dimension information from WMS capabilites.
   *
   * @param {Object} wmsCapabilities The WMS capabilities
   * @param {String} layerName The name of the layer
   * @return {String} The timeDimensions value
   */
  extractTimeDimensionsFromWmsCapabilities (wmsCapabilities, layerName) {
    try {
      const timeDimensions = wmsCapabilities
        .Capability
        .Layer
        .Layer.find(layer => layer.Name === layerName)
        .Dimension.find(dimension => dimension.name === 'time');
      return timeDimensions;
    } catch (error) {
      return;
    }
  }
};



// WEBPACK FOOTER //
// ./app/util/OwsCapabilities.js